import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
    root: {
        "& .MuiButtonBase-root": {
            fontWeight: "600 !important",
            fontSize: "12px !important",
            color: "#656575 !important",
            boxShadow: "0px 100px 309px rgba(210, 208, 225, 0.24), 0px 41.7776px 129.093px rgba(210, 208, 225, 0.172525), 0px 22.3363px 69.0192px rgba(210, 208, 225, 0.143066), 0px 12.5216px 38.6916px rgba(210, 208, 225, 0.12), 0px 6.6501px 20.5488px rgba(210, 208, 225, 0.0969343), 0px 2.76726px 8.55082px rgba(210, 208, 225, 0.0674749)",
            backgroundColor: "#FFFFFF !important",
            "&.MuiPaginationItem-root": {
                // selected
                "&.Mui-selected": {
                    backgroundColor: theme.palette.primary.primary300 + " !important",
                    color: "#227731 !important",
                },
            },
        },

    },
}));

export default useStyles;
